<template>
  <v-card-text v-if="rob">
    <v-overlay :value="safirIsLoading">
      <v-progress-circular indeterminate size="100" />
    </v-overlay>
    <v-card flat>
      <v-card-text class="mt-1">
        <v-row class="mt-1">
          <template v-if="rob.has_fichier">
            <v-btn @click="downloadRob(rob)" color="color_action" class="ma-1">
              <v-icon left>mdi-file-outline</v-icon>
              {{ $t("btn.rob.download") }}
            </v-btn>
            <v-spacer />
          </template>
          <v-btn color="color_action" @click="downloadExcel(rob)" class="ma-1">
            <v-icon left> mdi-file-excel-box-outline</v-icon>
            {{ $t("btn.rob.export") }}
          </v-btn>
          <template v-if="1 === 1 || rob.has_fichier">
            <v-spacer />
            <v-btn
              color="color_action"
              @click="deposeFacture(rob.id)"
              class="ma-1"
            >
              <v-icon left>mdi-creation</v-icon>
              {{ $t("btn.rob.create") }}
            </v-btn>
          </template>
          <v-spacer />
          <v-btn color="color_action" @click="closeRob(rob)" class="ma-1">
            <template v-if="rob.statut === 'ENCOURS'">
              <v-icon left>mdi-close</v-icon>
              {{ $t("btn.rob.close") }}
            </template>
            <template v-else>
              <v-icon left>mdi-chart-donut</v-icon>
              {{ $t("btn.rob.open") }}
            </template>
          </v-btn>
        </v-row>
        <v-row>
          <v-col>
            <alert-create-facture v-if="safirError" :errors="safirError" />
            <v-alert v-if="safir" type="success">
              {{ $t("facturesafir.ok") }}
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <template v-if="safir">
      <v-btn color="primary" @click="downloadCsv(safir[0].id)">
        Télécharger le fichier de facture généré
      </v-btn>
      <!--      <v-card flat v-for="(val, i) in safir[0].facturesafirs" :key="i">-->
      <!--        <v-card-text>-->
      <!--          <v-btn color="primary" @click="downloadCsv(val.id)"-->
      <!--          >Télécharger le fichier de facture généré-->
      <!--          </v-btn>-->
      <!--        </v-card-text>-->
      <!--      </v-card>-->
    </template>
    <v-card flat>
      <v-card-title
        ><!---->
        {{ $t("rob.description.facture") }}
      </v-card-title>

      <v-card-text>
        <v-tooltip
          color="indigo"
          bottom
          v-for="(val, i) in rob.facture_safirs"
          :key="i"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-chip color="primary" dark v-bind="attrs" v-on="on" class="ma-1">
              {{ val.created_at }}
            </v-chip>
            <v-btn icon color="primary" @click="downloadCsv(val.id)">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <ul>
            <li v-for="(item, i) in val.facturesafirs" :key="i">
              {{ item.ROB_CARTE_NAME }} - {{ item.ROB_LINE_DESCRIPTION }} -
              {{ item.ROB_LINE_AMOUNT_TTC }} &euro;
            </li>
          </ul>
        </v-tooltip>
      </v-card-text>
    </v-card>
    <v-card flat>
      <v-card-title> {{ $t("rob.description.detail") }}</v-card-title>
      <v-card-text>
        <v-list>
          <my-list-item
            :name="$t('rob.description.centreFacturation')"
            :value="rob.centre_facturation.libelle"
          />
          <my-list-item :name="$t('rob.description.date')" :value="rob.date" />
          <my-list-item
            :name="$t('rob.description.numero')"
            :value="rob.numero"
          />
          <my-list-item
            :name="$t('rob.description.debit')"
            :value="rob.montant_debit + ' €'"
          />
          <my-list-item
            :name="$t('rob.description.credit')"
            :value="rob.montant_credit + ' €'"
          />
          <my-list-item
            :name="$t('rob.description.nbLignesTotal')"
            :value="rob.lignesRob.total"
          />
          <my-list-item
            :name="$t('rob.description.nbLignesAnnule')"
            :value="rob.lignesRob.annule"
          />
          <my-list-item
            :name="$t('rob.description.nbLignestraite')"
            :value="rob.lignesRob.traite"
          />
          <my-list-item
            :name="$t('rob.description.montant.annule')"
            :value="rob.montant.annule + ' €'"
          />
          <my-list-item
            :name="$t('rob.description.montant.traite')"
            :value="Math.round(rob.montant.traite * 100) / 100 + ' €'"
          />
        </v-list>
      </v-card-text>
    </v-card>
  </v-card-text>
</template>

<script>
import { generalMixin } from "@/mixins/general";
import { robMixin } from "@/mixins/rob";
import MyListItem from "@/components/core/MyListItem";
import axios from "@/lib/axioxAppli";
import { safirMixin } from "@/mixins/safir";
// import AlertCreateFacture from "@/components/AlertCreateFacture.vue";
import AlertCreateFacture from "@/components/AlertCreateFacture";

const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;

export default {
  name: "VueRobDescription",
  components: { MyListItem, AlertCreateFacture },
  mixins: [generalMixin, robMixin, safirMixin],
  data() {
    return {
      URL_BACKEND: URL_BACKEND,
    };
  },
  methods: {
    closeRob() {
      const sta = this.rob.statut === "ENCOURS" ? "TRAITE" : "ENCOURS";
      this.rob.statut = sta;
      this.updateRob({
        id: this.rob.id,
        values: { statut: sta },
        list: this.robs,
      });
    },
    downloadRob(rob) {
      axios({
        url: URL_BACKEND + "api-rob/fichier/" + rob.id + "/",
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            rob.centre_facturation.dr + "_" + rob.date + ".xml"
          );
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch(() => {});
    },
    downloadExcel(rob) {
      axios({
        url: URL_BACKEND + "api-rob/extractRob/" + rob.id + "/",
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            rob.centre_facturation.dr + "_" + rob.date + ".xlsx"
          );
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch(() => {});
    },
    downloadCsv(id) {
      axios({
        url: URL_BACKEND + "api-safir/download/" + id + "/",
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "rob.csv");
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch(() => {});
    },
    deposeFacture(id) {
      this.resetFacture();
      this.createFacture(id);
    },
  },
  mounted() {
    this.resetFacture();
  },
};
</script>

<style scoped></style>
